module.exports = __webpack_public_path__ + "img/evaluacion-placeholder.8b8d0c9a.png";